import { Link } from 'react-router-dom';
import { categories } from '@/mocks/navData';

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="grid grid-cols-1 gap-8 px-4 py-10 md:grid-cols-12 md:px-8 md:py-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-compass-3-line text-xl"></i>
            </span>
            <span className="font-heading text-lg font-extrabold tracking-tight text-foreground-950">
              蓝导航
            </span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
            蓝导航是一个面向大众互联网用户的综合导航平台，聚合新闻、视频、购物、社交等多领域优质网站入口，帮助你更快找到目标网站，提升日常上网效率。
          </p>
          <div className="mt-5 flex flex-wrap gap-2">
            <span className="rounded-full bg-background-50 px-3 py-1 text-xs text-foreground-600">
              <i className="ri-shield-check-line mr-1 text-secondary-600"></i>
              安全外链
            </span>
            <span className="rounded-full bg-background-50 px-3 py-1 text-xs text-foreground-600">
              <i className="ri-flashlight-line mr-1 text-accent-600"></i>
              快速直达
            </span>
            <span className="rounded-full bg-background-50 px-3 py-1 text-xs text-foreground-600">
              <i className="ri-layout-grid-line mr-1 text-primary-600"></i>
              分类清晰
            </span>
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-heading text-sm font-semibold text-foreground-950">
            导航分类
          </h4>
          <ul className="mt-4 grid grid-cols-2 gap-2 md:grid-cols-1">
            {categories.map((category) => (
              <li key={category.slug}>
                <Link
                  to={`/category/${category.slug}`}
                  className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-600"
                >
                  {category.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="font-heading text-sm font-semibold text-foreground-950">
            关于与帮助
          </h4>
          <ul className="mt-4 flex flex-col gap-2">
            <li>
              <Link
                to="/about"
                className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-600"
              >
                关于蓝导航
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-600"
              >
                反馈与建议
              </Link>
            </li>
            <li>
              <Link
                to="/search?q=购物"
                className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-600"
              >
                热门搜索
              </Link>
            </li>
          </ul>
          <p className="mt-4 text-xs leading-relaxed text-foreground-500">
            本站所有导航入口均为外链跳转，内容与服务质量由目标网站提供，蓝导航仅作收录与整理。
          </p>
        </div>
      </div>

      <div className="flex flex-col items-center justify-between gap-3 border-t border-background-200 px-4 py-5 text-xs text-foreground-500 sm:flex-row md:px-8">
        <p>© 2026 蓝导航 版权所有 · 本站为演示站点，数据均为示例内容</p>
        <p className="flex items-center gap-1.5">
          <i className="ri-information-line"></i>
          搜索与反馈功能均为前端演示，无需真实数据
        </p>
      </div>
    </footer>
  );
}